import { render } from "./ReceiveCallMenu.vue?vue&type=template&id=9f7846d2"
import script from "./ReceiveCallMenu.vue?vue&type=script&lang=js"
export * from "./ReceiveCallMenu.vue?vue&type=script&lang=js"

import "./ReceiveCallMenu.vue?vue&type=style&index=0&id=9f7846d2&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__